import { render, staticRenderFns } from "./fontawesome.vue?vue&type=template&id=0900e4ea"
import script from "./fontawesome.vue?vue&type=script&lang=js"
export * from "./fontawesome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports